module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="container-fluid">\r\n    <div class="row">\r\n        <div class="content col-xs-12">\r\n            <h2 class="title">\r\n                '+
((__t=(lang.ENVIRO))==null?'':_.escape(__t))+
'\r\n            </h2>\r\n            <div class="form-group">\r\n                <div class="row">\r\n\r\n                </div>\r\n            </div>\r\n            <div class="col-xs-10 col-xs-offset-1 instancesContent">\r\n                ';

                _.each(models, function(model){
                    print('<div data-id="' + model.id + '" class="col-xs-3 col-xs-offset-1 instanceItem"><img type="icon" id="icon' + model.id + '"/><br/>' + model.attributes.name + '</div>');
                });
                
__p+='\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div id="AreasCarpeta" class="row foldercont"></div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/instances_s/instancesView.ejs
// module id = 423
// module chunks = 0